import DefaultException from './DefaultException';

import temporarySystemDisruptionImage from 'common/res/images/temporarySystemDisruption/empty_state_temporary_system_disruption.png';

export default class TemporarySystemDisruptionException extends DefaultException {
  constructor(
    message,
    { title, ctaButtonLabel, onClickCtaButton, hideCtaButton }
  ) {
    super(message);

    this.title = title;
    this.hideCtaButton = hideCtaButton;
    this.ctaButtonLabel = ctaButtonLabel;
    this.onClickCtaButton = onClickCtaButton;
    this.image = temporarySystemDisruptionImage;
  }
}
